var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalRedLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 128,
    viewBox: "0 0 5 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.25881,
    y1: 0.425781,
    x2: 2.2588,
    y2: 127.52,
    stroke: "#B02526",
    strokeWidth: 3.58011
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalRedLine);
export default __webpack_public_path__ + "static/media/verticalRedLine.5e473e9efe07ba0e1d7befae2798eb14.svg";
export { ForwardRef as ReactComponent };